import { render } from "./TranslatorPage.vue?vue&type=template&id=d27a2ce0&scoped=true"
import script from "./TranslatorPage.vue?vue&type=script&lang=js"
export * from "./TranslatorPage.vue?vue&type=script&lang=js"

import "./TranslatorPage.vue?vue&type=style&index=0&id=d27a2ce0&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/webshop/core-editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d27a2ce0"]])

export default __exports__